module.exports = __webpack_public_path__ + "static/media/addressImage.16559172.svg";